<script setup lang="ts">
import { useAgreementStore } from '@/stores/agreement';
import type { SamAgreement } from '@/types';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

const { agreement, samAgreements } = storeToRefs(useAgreementStore())

const show = ref(false)
const samAgreement = computed<SamAgreement | undefined>(() => {
  if (!agreement.value.agreementId) return undefined

  return samAgreements.value?.find(item => item.id === agreement.value.agreementId)
})
</script>

<template>
  <v-dialog
    v-model="show"
    transition="dialog-bottom-transition"
    fullscreen
    scrollable
  >
    <template #activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        :disabled="!samAgreement"
        text="Læs hele aftalen"
        prepend-icon="mdi-file"
        variant="elevated"
        block
      />
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <div>
          {{ samAgreement?.name }}
        </div>
        <v-btn icon="mdi-close" size="small" variant="text" @click="show = false"></v-btn>
      </v-card-title>

      <v-card-text v-html="samAgreement?.description" />
    </v-card>
  </v-dialog>
</template>